// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce-product-reviews-search-input {
    width: 600px !important;
    height: 48px;
    border: 1px solid var(--color-ec-border) !important;
    border-radius: 6px !important;
    padding: 12px !important;
    color: var(--color-ec-body) !important;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    line-height: 26px;
}`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/ProductReviews/ProductReviewsList/style.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,YAAY;IACZ,mDAAmD;IACnD,6BAA6B;IAC7B,wBAAwB;IACxB,sCAAsC;IACtC,gCAAgC;IAChC,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".easycommerce-product-reviews-search-input {\n    width: 600px !important;\n    height: 48px;\n    border: 1px solid var(--color-ec-border) !important;\n    border-radius: 6px !important;\n    padding: 12px !important;\n    color: var(--color-ec-body) !important;\n    font-family: \"Inter\", sans-serif;\n    font-size: 16px;\n    line-height: 26px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
